<template>
  <v-container fluid align-content-center>
    <MailClient></MailClient>



    <!-- <swiper :options="swiperOption">
         <swiper-slide
         v-for="item in modelObjects" :key="item.id"
         >

         <v-card height="660px" hover @click="$emit('selectTemplate', item.id)">
         <v-responsive :aspect-ratio="0.7">
         <v-card-title primary-title class="justify-center">
         <v-expand-x-transition>
         <v-icon
         v-if="item.id == templateId"
         x-large
         color="success"
         transition="fade-transition"
         class="text-xs-left"
         >
         check_circle_outline
         </v-icon>
         </v-expand-x-transition>
         <h3 class="headline mb-2 pl-2">{{ item.name }}</h3>
         </v-card-title>
         <v-divider  :key="item.id"></v-divider>
         <v-img
         v-if="item.template_image"
         :src="item.template_image"
         contain
         ></v-img>
         <v-card-actions>
         </v-card-actions>
         </v-responsive>
         </v-card>
         </swiper-slide>
         <div class="swiper-button-prev" slot="button-prev"></div>
         <div class="swiper-button-next" slot="button-next"></div>
         <div class="swiper-pagination" slot="pagination"></div>
         </swiper> -->


    <carousel
      :perPage=1
      :perPageCustom="[[960, 2], [1264, 3]]"
      :navigationEnabled=true
      navigationNextLabel=""
      navigationPrevLabel=""
      paginationColor="#90CAF9"
      paginationActiveColor="#0D47A1"
      :paginationSize=25
      :paginationPadding=5
    >
      <slide
        v-for="item in modelObjects" :key="item.id"
      >
        <v-card
          height="660px"
          max-height="750"
          elevation=8 class="ma-3"
          hover @click="$emit('selectTemplate', item.id)"
        >
          <v-card-title primary-title class="justify-center amber lighten-1 white--text">
            <v-expand-x-transition>
              <v-icon
                v-if="item.id == templateId"
                x-large
                color="primary"
                transition="fade-transition"
                class="text-xs-left"
              >
                check_circle_outline
              </v-icon>
            </v-expand-x-transition>
            <h3 class="headline mb-2 pl-2">{{ item.name }}</h3>
          </v-card-title>
          <v-divider :key="item.id"></v-divider>
          <v-img
            v-if="item.template_image"
            :src="item.template_image"
            contain
          ></v-img>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </slide>
    </carousel>


  </v-container>
</template>

<script>

 /*
    Important!!!
    Le v-container doit être fluid sinon le swiper est mal contenu
    dans le container sa responsivité est mauvaise.
  */

 import { mixin_ajax } from '../components/mixin_ajax_vue.js';
 import MailClient from '../components/MailClient';
 import { Carousel, Slide } from 'vue-carousel';

 // surmon-china/vue-awesome-swiper
 /* import { swiper, swiperSlide } from 'vue-awesome-swiper'
  * import 'swiper/dist/css/swiper.css' */

 export default {
   components: {
     /* swiper,
      * swiperSlide, */
     MailClient,
     Carousel,
     Slide,
   },
   props: ['templateId'],
   mixins: [mixin_ajax],
   data() {
     return {
       api_url: '/api/cvmodels/',
       modelObjects: [],
       newModelObject: function() {
         return null;
       },
       swiperOption: {
         // options pour surmon-china/vue-awesome-swiper
         slidesPerView: 3,
         centerInsufficientSlides: true,
         // spaceBetween: 30,
         // slidesOffsetBefore: 40,
         // slidesOffsetAfter: 40,
         pagination: {
           el: '.swiper-pagination',
           // type: 'progressbar',
           clickable: true
         },
         navigation: {
           nextEl: '.swiper-button-next',
           prevEl: '.swiper-button-prev'
         },
         watchOverflow: true,
         breakpointsInverse: true,
         breakpoints: {
           // when window width is >= 320px
           0: {
             slidesPerView: 1,
             spaceBetween: 0,
             centerInsufficientSlides: true,
           },
           // when window width is >= 480px
           960: {
             slidesPerView: 2,
             spaceBetween: 30
           },
           // when window width is >= 640px
           1264: {
             slidesPerView: 3,
             spaceBetween: 30
           }
         },
       }
     }
   },

 }
</script>

<style>
 .swiper-pagination-bullet {
     width: 20px;
     height: 20px;
 }
 .swiper-button-prev {
     left: 0 !important;
     /* background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%234c71ae'%2F%3E%3C%2Fsvg%3E") !important; */
 }
 .swiper-button-next {
     right: 0 !important;
     /* background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%234c71ae'%2F%3E%3C%2Fsvg%3E") !important; */
 }


 /* vue crousel */

 .VueCarousel-navigation-button {
     content: "";
     position: absolute;
     top: 8px;
     height: 35px;
     width: 25px;
 }

 .VueCarousel-navigation-next {
     background: url(../assets/ICONS/2x/baseline_arrow_forward_ios_black_18dp.png);
     right: 6px;
     margin-right:10px;
 }

 .VueCarousel-navigation-prev {
     background: url(../assets/ICONS/2x/baseline_arrow_back_ios_black_18dp.png);
     left: 6px;
     margin-left:10px;
 }


</style>
